/*
 Sets input invalid if input value does not equal with value provided by attribute argument
 */
'use strict';


class SyncedDirective {
    restrict = 'A';
    require = 'ngModel';

    link(scope, element, attr, ngModelCtrl) {
        function areValuesInSync(thisValue) {
            var syncedValue = scope.$eval(attr.synced);
            return !syncedValue || thisValue === syncedValue;
        }

        if (attr.syncedEnable) {
            scope.$watch(
                () => scope.$eval(attr.syncedEnable),
                (newValue) => ngModelCtrl.$setValidity('synced', !newValue || areValuesInSync(ngModelCtrl.$viewValue))
            );
        }

        ngModelCtrl.$parsers.push((viewValue) => {
            var valid = areValuesInSync(viewValue);
            ngModelCtrl.$setValidity('synced', valid);
            if (valid) {
                return viewValue;
            }
            return undefined;
        });

    }
}

export default () => new SyncedDirective();


// WEBPACK FOOTER //
// ./src/ui/core/common/directives/decorator/synced.directive.js